<template>
  <v-footer inset app >
    <v-spacer></v-spacer>
    <span class="px-4 caption">&copy; {{ year }} - {{ titleApp }} | Desenvolvido por
      <a
        href="http://www.kmdois.com.br"
        target="_blank">KM2</a></span>
  </v-footer>
</template>

<script>
export default {
  data() {
    return {
      titleApp: this.$appName,
      year: new Date().getFullYear()
    }
  }
}
</script>